import React, { useMemo, useState } from "react";
import { Pressable, Text, View } from "react-native";

import AIExhibitNarrationPressable from "../audio/AIExhibitNarrationPressable";
import { useAIExhibitFixedNarration } from "../audio/useAIExhibitFixedNarration";
import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";

const NARRATION_BY_MYTH_ID = Object.freeze({
  robot: "ai_myth_robot",
  search: "ai_myth_search",
  understands: "ai_myth_understands",
  conscious: "ai_myth_conscious",
  objective: "ai_myth_objective",
  correct: "ai_myth_correct",
});
import { getAIExhibitBatch5Copy } from "../content/aiExhibitBatch5Content";

export default function AIMythsScreen({
  language = "en",
  audioEnabled = false,
}) {
  const { playNarration } = useAIExhibitFixedNarration({
    audioEnabled,
    language,
  });
  const t = getAIExhibitBatch5Copy(language).myths;
  const [mythId, setMythId] = useState(null);

  const myth = useMemo(
    () => t.myths.find((item) => item.id === mythId) || null,
    [mythId, t.myths]
  );

  return (
    <View style={{ padding: 28 }}>
      <Text style={{ color: C.accent, fontSize: 13, fontWeight: "900", letterSpacing: 1.2 }}>
        {t.eyebrow}
      </Text>

      <Text style={{ color: C.text, fontSize: 44, lineHeight: 50, fontWeight: "900", marginTop: 8 }}>
        {t.title}
      </Text>

      <Text style={{ color: C.muted, fontSize: 18, lineHeight: 27, marginTop: 8, maxWidth: 980 }}>
        {t.subtitle}
      </Text>

      <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 12, marginTop: 24 }}>
        {t.myths.map((item) => {
          const active = item.id === mythId;

          return (
            <Pressable
              key={item.id}
              onPress={() => {
                setMythId(item.id);
                playNarration(NARRATION_BY_MYTH_ID[item.id]);
              }}
              style={({ pressed }) => ({
                width: "48.7%",
                minWidth: 320,
                flexGrow: 1,
                minHeight: 120,
                padding: 20,
                borderRadius: 17,
                borderWidth: active ? 2 : 1,
                borderColor: active ? C.accent : C.border,
                backgroundColor: active || pressed ? C.accentSoft : C.surfaceRaised,
                justifyContent: "center",
              })}
            >
              <Text style={{ color: C.text, fontSize: 20, lineHeight: 28, fontWeight: "900" }}>
                {item.claim}
              </Text>
            </Pressable>
          );
        })}
      </View>

      {myth ? (
        <View style={{ marginTop: 18, padding: 22, borderRadius: 18, borderWidth: 1, borderLeftWidth: 6, borderColor: C.border, borderLeftColor: C.accent, backgroundColor: C.surfaceRaised }}>
          <Text style={{ color: C.accent, fontSize: 27, lineHeight: 34, fontWeight: "900" }}>
            {myth.verdict}
          </Text>
          <Text style={{ color: C.text, fontSize: 18, lineHeight: 29, marginTop: 10 }}>
            {myth.explanation}
          </Text>
        </View>
      ) : (
        <View style={{ marginTop: 18, padding: 22, minHeight: 125, borderRadius: 18, borderWidth: 1, borderColor: C.border, backgroundColor: C.surfaceRaised, alignItems: "center", justifyContent: "center" }}>
          <Text style={{ color: C.muted, fontSize: 17, textAlign: "center" }}>
            {language === "es"
              ? "Toca una afirmación para revelar la explicación."
              : "Tap a claim to reveal the explanation."}
          </Text>
        </View>
      )}

      <AIExhibitNarrationPressable
        audioEnabled={audioEnabled}
        onPress={() => playNarration("ai_myths_takeaway")}
        style={{ marginTop: 16, padding: 18, borderRadius: 16, borderLeftWidth: 5, borderWidth: 1, borderColor: C.border, borderLeftColor: C.warning, backgroundColor: C.accentSoft }}
      >
        <Text style={{ color: C.text, fontSize: 17, lineHeight: 26, fontWeight: "800" }}>
          {t.takeaway}
        </Text>
      </AIExhibitNarrationPressable>
    </View>
  );
}
